<template lang="pug">
aside(v-if="type == 'aside'").column.is-3-desktop.is-hidden-mobile
  template(v-for="(f, index) in filteredFacets")
    .panel.facet(v-if="f.hidden")
      p.panel-heading {{ $t('facets.' + f.key) }}
        a.fa.fa-fw.fa-angle-down.is-pulled-right(@click="showFacet(f)")
    .panel.facet.is-open(v-else :class="{ 'is-expanded': f.expanded }")
      p.panel-heading {{ $t('facets.' + f.key) }}
        a.fa.fa-fw.fa-angle-up.is-pulled-right(@click="hideFacet(f)")
      .panel-block(v-if="f.isFilterable" )
        p.control.has-icons-left
          input.input.is-small(type="text", placeholder="Filter" v-model.trim="filteredFacets[index].filterString")
          span.icon.is-small.is-left
            i.fa.fa-search
      template(v-if="f.isFilterable")
        search-facet-values(v-for="i in f.values.filter((v) => {return v.selected})" :facet="f" :value="i" :key="'aside' + i.caption" :type="type")
        search-facet-values(v-for="i in f.values.filter((v) => {return !v.selected})" :facet="f" :value="i" :key="'aside' + i.caption" :type="type")
      template(v-else)
        search-facet-values(v-for="i in f.values" :facet="f" :value="i" :key="'tag' + i.caption" :type="type")
      .panel-block(v-if="!f.expanded && f.values && f.values.length > 3")
        button.button.is-text.is-small.is-fullwidth(@click="expand(f)") {{ $t('facets.showAll') }}
.field(v-else-if="type == 'tag'").is-grouped.is-grouped-multiline
  template(v-for="(f, index) in selectedFacets")
    search-facet-values(v-for="i in f.values" :facet="f" :value="i" :key="'tag' + i.caption" :type="type")
</template>

<script>
const { mapState } = require("vuex");
const facets = require("../../helpers/facets");
const { messages } = require("../../i18n/facets");

export default {
    name: "search-facets",
    components: {
        SearchFacetValues: require("./SearchFacetValues").default
    },

    i18n: { messages },

    computed: {
        ...mapState("search", ["archives", "persons", "projects", "sections", "volumes", "routeQuery", "titles", "total"]),

        allFacets() {
            let activeHierarchicFacets = getActiveHierarchicFacets(this.routeQuery, this.sections, this.archives);
            return [
                facets.model("abt", activeHierarchicFacets.activeSections, facets.sectionSort, this.selections, true),
                facets.model("archiv", activeHierarchicFacets.activeArchives, facets.sectionSort, this.selections, true),
                // og decided (2018-10-09) to hide this facet until somebody misses it
                // facets.model("band", this.volumes, facets.countSort, this.selections),
                facets.model("title", this.titles, facets.countSort, this.selections, false, true),
                facets.model("project", this.projects, facets.countSort, this.selections, false, true),
                facets.model("person", this.persons, facets.countSort, this.selections, false, true)
            ];
        },

        selectedFacets() {
            const selFacets = [];

            for(const key in this.selections) {
                if(key.indexOf("Prefixes") == -1)  {
                    const f = this.filteredFacets.filter((f) => f.key == key)[0];
                    f.values = f.values.filter((v) => v.selected == true && v.caption == this.selections[key]);
                    selFacets.push(f);
                }
            }

            return selFacets;
        },

        selections() {
            let selection = {};
            Object.keys(this.routeQuery).forEach((item) => {
                if(item !== "q") {
                    selection[item] = this.routeQuery[item];
                }
            });
            return selection;
        },
    },

    data: () => {
        return {
            filteredFacets: []
        }
    },

    props: ["type"], // distinguish between visualization type == "aside" and type == "tag"

    methods: {
        expand(facet) {
            facet.expanded = true;
            this.filteredFacets.filter((f) => f.key == facet.key)[0].expanded = true;
        },

        facetName(facetKey) {
            return facets.names[facetKey];
        },

        hideFacet(facet) {
            facet.hidden = true;
            this.filteredFacets.filter((f) => f.key == facet.key)[0].hidden = true;
        },

        showFacet(facet) {
            facet.hidden = false;
            this.filteredFacets.filter((f) => f.key == facet.key)[0].hidden = false;
        }
    },

    mounted: function() {
        populateFilteredFacets(this);
    },

    watch: {
        allFacets: {
            handler: function(newFF, oldFF) {
                let that = this;
                if(newFF.some((f, i) => f.filterString != oldFF[i].filterString || f.values.length != oldFF[i].values.length )) {
                    populateFilteredFacets(that);
                }
            }
        }
    }
}

function filterFacet(vueModel, facet) {
    const unfilteredFacet = vueModel.allFacets.filter((f) => f.key === facet.key)[0];
    facet.values = unfilteredFacet.values.filter((v) => v.caption.toLowerCase().includes(facet.filterString.toLowerCase()))
}

function getActiveHierarchicFacets( routeQuery, sections, archives ) {
    const hierarchicFacets = Object.assign({}, sections, archives);
    const activeKeys = [];
    const { abtFacetPrefixes, archivFacetPrefixes } = routeQuery;
    if (hasActiveHierarchyNavigation(routeQuery)) {
        const mergedPrefixes = [];
        mergedPrefixes.push(abtFacetPrefixes);
        mergedPrefixes.push(archivFacetPrefixes);
        for (const prefix of mergedPrefixes.filter((v) => v).flat(3)) {
            activeKeys.push(...Object.keys(hierarchicFacets).filter((k) => k.startsWith(prefix) && !k.startsWith("1/")));
            // always display top-level prefixes
            activeKeys.push(...Object.keys(hierarchicFacets).filter((k) => k.startsWith("1/")));
        }
    }
    else {
        activeKeys.push(...Object.keys(hierarchicFacets).filter((k) => k.startsWith("1/")));
    }
    let activeSections = {};
    let activeArchives = {};
    for (const key of activeKeys) {
        if(sections[key]) {
            activeSections[key] = hierarchicFacets[key];
        }
        else if(archives[key]) {
            activeArchives[key] = hierarchicFacets[key];
        }
    }
    return { activeSections, activeArchives };
}

function hasActiveHierarchyNavigation(routeQuery) {
    const { abtFacetPrefixes, archivFacetPrefixes } = routeQuery;
    return abtFacetPrefixes && abtFacetPrefixes.length > 0 || archivFacetPrefixes && archivFacetPrefixes.length > 0;
}

function populateFilteredFacets(vueModel) {
    const filteredFacets = [];

    for(let facet of vueModel.allFacets) {
        if(!facet.isFilterable || !facet.filterString){
            filteredFacets.push(Object.assign({}, facet));
        } else {
            const { expanded, filterString, isFilterable, isHierarchical, key, name, selected } = facet
            filteredFacets.push(Object.assign({}, {
                expanded, filterString, isFilterable, isHierarchical, key, name, selected,
                values: facet.values.filter((v) => v.caption.toLowerCase().includes(facet.filterString.toLowerCase()))
            }));
        }
    }

    vueModel.filteredFacets = filteredFacets;

    for(let i in vueModel.filteredFacets) {
        if(vueModel.filteredFacets[i].isFilterable) {
            const facet = vueModel.filteredFacets[i];
            vueModel.$watch(["filteredFacets", i, "filterString"].join("."), function () {
                filterFacet(vueModel, facet);
            })
        }
    }
}
</script>